import lazyLoading from './config';

export default [
    {
        path: '/404',
        meta: {
            title: '404',
            noNav: true
        },
        component: resolve => lazyLoading(resolve, 'error/404')
    }
];
